// extracted by mini-css-extract-plugin
export default {"placeholder":"index_placeholder_BKnGn","wrap":"index_wrap_4t7uG","content":"index_content_hsEcT"};